var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import AccessibleFakeInkedButton from '../Helpers/AccessibleFakeInkedButton';
import TileAddon from '../Lists/TileAddon';
var MiniListItem = function (_PureComponent) {
  _inherits(MiniListItem, _PureComponent);
  function MiniListItem() {
    var _temp, _this, _ret;
    _classCallCheck(this, MiniListItem);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = {
      active: false
    }, _this._handleMouseOver = function (e) {
      if (_this.props.onMouseOver) {
        _this.props.onMouseOver(e);
      }
      if (!_this.props.disabled) {
        _this.setState({
          active: true
        });
      }
    }, _this._handleMouseLeave = function (e) {
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave(e);
      }
      if (!_this.props.disabled) {
        _this.setState({
          active: false
        });
      }
    }, _this._handleTouchStart = function (e) {
      if (_this.props.onTouchStart) {
        _this.props.onTouchStart(e);
      }
      _this._touched = true;
      _this.setState({
        active: true,
        touchedAt: Date.now()
      });
    }, _this._handleTouchEnd = function (e) {
      if (_this.props.onTouchEnd) {
        _this.props.onTouchEnd(e);
      }
      var time = Date.now() - _this.state.touchedAt;
      _this._touchTimeout = setTimeout(function () {
        _this._touchTimeout = null;
        _this.setState({
          active: false
        });
      }, time > 450 ? 0 : 450 - time);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  MiniListItem.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this._touchTimeout) {
      clearTimeout(this._touchTimeout);
    }
  };
  MiniListItem.prototype.render = function render() {
    var _props = this.props,
      style = _props.style,
      className = _props.className,
      tileStyle = _props.tileStyle,
      tileClassName = _props.tileClassName,
      leftIcon = _props.leftIcon,
      leftAvatar = _props.leftAvatar,
      active = _props.active,
      activeClassName = _props.activeClassName,
      ItemComponent = _props.itemComponent,
      primaryText = _props.primaryText,
      secondaryText = _props.secondaryText,
      rightIcon = _props.rightIcon,
      rightAvatar = _props.rightAvatar,
      threeLines = _props.threeLines,
      children = _props.children,
      defaultOpen = _props.defaultOpen,
      isOpen = _props.isOpen,
      inset = _props.inset,
      nestedItems = _props.nestedItems,
      animateNestedItems = _props.animateNestedItems,
      expanderIcon = _props.expanderIcon,
      expanderIconChildren = _props.expanderIconChildren,
      expanderIconClassName = _props.expanderIconClassName,
      props = _objectWithoutProperties(_props, ['style', 'className', 'tileStyle', 'tileClassName', 'leftIcon', 'leftAvatar', 'active', 'activeClassName', 'itemComponent', 'primaryText', 'secondaryText', 'rightIcon', 'rightAvatar', 'threeLines', 'children', 'defaultOpen', 'isOpen', 'inset', 'nestedItems', 'animateNestedItems', 'expanderIcon', 'expanderIconChildren', 'expanderIconClassName']);
    return React.createElement(ItemComponent, {
      style: style,
      className: className
    }, React.createElement(AccessibleFakeInkedButton, _extends({}, props, {
      style: tileStyle,
      className: cn('md-list-tile md-list-tile--icon md-list-tile--mini', {
        'md-list-tile--active': this.state.active && !this._touched
      }, tileClassName),
      onMouseOver: this._handleMouseOver,
      onMouseLeave: this._handleMouseLeave,
      onTouchStart: this._handleTouchStart,
      onTouchEnd: this._handleTouchEnd
    }), React.createElement(TileAddon, {
      active: active,
      activeClassName: activeClassName,
      icon: leftIcon,
      avatar: leftAvatar
    })));
  };
  return MiniListItem;
}(PureComponent);
MiniListItem.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  tileStyle: PropTypes.object,
  tileClassName: PropTypes.string,
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.object]),
  active: PropTypes.bool,
  activeClassName: PropTypes.string,
  leftIcon: PropTypes.node,
  leftAvatar: PropTypes.node,
  disabled: PropTypes.bool,
  onTouchStart: PropTypes.func,
  onTouchEnd: PropTypes.func,
  onMouseOver: PropTypes.func,
  onMouseLeave: PropTypes.func,
  defaultOpen: PropTypes.bool,
  itemComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]).isRequired
};
MiniListItem.defaultProps = {
  activeClassName: 'md-text--theme-primary',
  component: 'div',
  itemComponent: 'li'
};
export default MiniListItem;